export default __webpack_public_path__ + "static/media/cp_gh_github.255db585.svg";